import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import SimpleBlock from '../Block'

const SubTitleBlock = (props: IBlockProps): ReactElement => <SimpleBlock {...props} type="subtitle" />

export default SubTitleBlock
